var _defs, _use, _mask, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClubStripBgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1464,
    height: 631,
    viewBox: "0 0 1464 631",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "eei3m7rdfa",
    d: "M0 0h1464v631H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "93113sd8xb",
    d: "M0 0h1464v631H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#F3F4F7",
    xlinkHref: "#eei3m7rdfa"
  })), /*#__PURE__*/React.createElement("g", null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ms8tvo2kvc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#93113sd8xb"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#2E2D79",
    xlinkHref: "#93113sd8xb"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.849,
    mask: "url(#ms8tvo2kvc)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.717
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.504,
    fill: "#9C9C9C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.157 156.276 1912.152)",
    d: "m578.431 349.337 1986.064 1735.774 292.197 733.19L870.628 1082.525z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.153 484.647 2098.417)",
    d: "m1537.744 1310.71 998.02 872.209 18.5 46.404-998.02-872.208z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.115 1142.989 1789.282)",
    d: "m2203.16 1017.838 999.257 873.077 4.63 11.6-999.258-873.078z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "rotate(-62.153 -64.311 1845.252)",
    d: "M405.175 400.561 2390.755 2135.9l198.16 497.244L603.34 897.805z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubStripBgDesktop);
export default __webpack_public_path__ + "static/media/club-strip-bg-desktop.35bbfa2c3ffa5ee06e9c85a7e1e830f6.svg";
export { ForwardRef as ReactComponent };